//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () { return { roots: [], rootId: null, treeName: '', nickname: '园丁', keyword: '' } },
  created () { this.search() },
  methods: {
    search () {
      const q = this.keyword ? ('?keyword=' + encodeURIComponent(this.keyword)) : ''
      this.$ajax.get(this.$api.etRootList + q).then(r => { this.roots = r || [] })
    },
    create () {
      this.$ajax.post(this.$api.etTreeCreate, {
        root_id: this.rootId, tree_name: this.treeName || undefined, nickname: this.nickname
      }).then(r => {
        this.$router.replace({ path: '/etDetail_display', query: { id: r.id } })
      }).catch(e => { this.$toast && this.$toast(e.message || '失败') })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/etymology-tree/create.vue